<template>

<app-content :loading="is.loading">

	<app-content-head :title="'Loan #' + item.reference" back="Convention.Checkout.Loans" :readonly="$authorised('con/checkout/access', 'read')">

		<app-content-head-actions-item :loading="is.saving" text="Add" icon="checkout.player" v-on:click="onAddClick" v-tooltip="'Add player to loan'" />

		<app-content-head-actions-item v-if="item.statusReturn !== $constants.checkout.loan.tag.returned" :loading="is.returning" text="Returned" icon="returned" v-on:click="onReturnClick" />

		<app-content-head-actions-item :disabled="is.returning || is.saving" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" v-if="is.initialised">

		<app-content-summary>

			<app-content-summary-item label="Status" :tag="$constants.checkout.loan.tagName[item.statusReturn]" :theme="$constants.checkout.loan.tagTheme[item.statusReturn]" />
			
			<app-content-summary-item label="Reference" :value="item.reference" />
			
			<app-content-summary-item label="Game" :value="item.game.name" :note="item.game.reference" :link="linkGame" :grow="true" />
			
			<app-content-summary-item label="Badge" :value="item.badge.name" :note="item.badge.reference" :link="linkBadge" :grow="true" />
			
			<app-content-summary-item label="Hours" :value="item.hours" />
			
			<app-content-summary-item label="Players" :value="item.players.length" />
			
			<app-content-summary-item label="Checked Out" :value="item.date.out | localDate('h:mma, dddd')" />
			
			<app-content-summary-item v-if="item.date.in" label="Checked In" :value="item.date.in | localDate('h:mma, dddd')" />

		</app-content-summary>

		<com-players :loan="item.id" v-on:removed="onPlayerRemoved" :players="item.players.length" />

		<app-content-section v-if="item.game.playtowin" icon="game.icon.playtowin" :is-slim="true" title="This game is part of Play to Win" description="Click to view details." :route="linkWin" />
		
		<app-content-section v-if="item.game.reported" icon="game.icon.report" :is-slim="true" title="This game has an open report" description="Click to view details." :route="linkReport" />

	</app-content-body>

	<app-input-items-find title="Find player to add" placeholder="Search by badge name or reference" v-if="is.adding" api="convention/badge" :is-single="true" :exclude="item.players" v-on:save="onAddSaveClick" v-on:close="is.adding = false" />

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'
import comPlayers from './conventioncheckoutloan/Players'

export default {

	mixins: [mixForm],

	components: {
		'com-players': comPlayers
	},

	data: function() {

		return {
			references: {},
			readonly: this.$authorised('con/checkout/access', 'read'),
            is: {
                returning: false,
				adding: false
            },
			model: {
                game: false
            }
		}

	},

	validations: {
		model: {
			game: { required }
		}
	},

	computed: {

		linkWin: function() {
		
			return (this.item.game.playtowin) ? {
				name: 'Convention.Checkout.Wins.Edit',
				params: {
					id: this.item.game.playtowin
				}
			} : false

		},

		linkReport: function() {
		
			return (this.item.game.reported) ? {
				name: 'Convention.Checkout.Reports.Edit',
				params: {
					id: this.item.game.reported
				}
			} : false

		},

		linkGame: function() {
		
			return (this.item.game && !this.item.game.deleted) ? {
				name: 'Convention.Library.Games.Edit',
				params: {
					id: this.item.game.id
				}
			} : false
		
		},

		linkBadge: function() {
		
			return (this.item.badge) ? {
				name: 'Convention.Badges.Holders.Edit',
				params: {
					id: this.item.badge.id
				}
			} : false
		
		}
	
	},

    methods: {

		afterLoad: function() {

			if(this.is.saving) {

				this.$notify({
					message: 'Player added successfully.'
				})
		
				this.is.saving = false
			
			}

		},

		onPlayerRemoved: function() {
		
			this.loadItem()

		},

		onAddClick: function() {
		
			this.is.adding = true

		},

		onAddSaveClick: function(value) {
		
			this.is.adding = false
			this.is.saving = true

			this.$api.post(['convention/checkout/loan', this.item.id, 'players'], {
				id: value[0]
			}).then(function() {

				this.loadItem()

			}.bind(this), function() {

				this.$notify({
					type: 'error',
					message: 'Sorry, player could not be added.'
				})

				this.is.saving = false
			
			}.bind(this))

		},
    
        onReturnClick: function() {
        
            this.is.returning = true

            this.$api.post(['convention/checkout/loan', this.item.id, 'return']).then(function() {

                this.$notify({
                    message: 'Loan successfully returned.'
                })
            
                this.is.returning = false

                this.load()

            }.bind(this), function() {

                this.$notify({
                    message: 'Sorry return failed, please try again.',
                    type: 'error'
                })
            
                this.is.returning = false

            }.bind(this))
        
        }
    
    }

}

</script>

<style scoped>

</style>